import {AOOSShopperStatus, DynamicTextType} from '@buncha/batchDetails/types';

import {OrderItem} from './ItemScanner';
import {OrderItem as OrderItemHome} from '@buncha/home/types';

/* eslint-disable no-shadow */
export enum SubstitutionChoice {
  byShopper = 'byShopper',
  byBuyer = 'byBuyer',
  noSubstitution = 'noSubstitution',
  none = 'none',
  anyBrand = 'anyBrand',
  meijerBrand = 'meijerBrand',
  nationalBrand = 'nationalBrand',
}

export enum SubstitutionMode {
  approvedThroughApp = 'approvedThroughApp',
  approvedOverCallAfterRequestSend = 'approvedOverCallAfterRequestSend',
  approvedOverCallBeforeRequestSend = 'approvedOverCallBeforeRequestSend',
}

export enum AdjacentOOSItemStatus {
  requestedToShopper = 'requestedToShopper',
  itemFoundAtShopper = 'itemFoundAtShopper',
  itemNotFoundAtShopper = 'itemNotFoundAtShopper',
  requestSentToBuyer = 'requestSentToBuyer',
  requestAcceptedByBuyer = 'requestAcceptedByBuyer',
  noResponseFromBuyer = 'noResponseFromBuyer',
  requestDeniedByBuyer = 'requestDeniedByBuyer',
}

export interface ItemLocationInformation {
  aisle: string;
  catalogItemId: number;
  esIndex: string;
  foundHere: string;
  id: number;
  itemForReplacement: any;
  locationImage: string;
  orderItemId: number;
  price: number;
  reportMissing: number;
  storeContext: string;
  upcOrderItemId: number;
}

export interface SubstitutionOptions {
  id: number;
  name: string;
}

export interface Buyers {
  id: number;
  firstName: string;
  lastName: string;
  conversationId?: string;
  phoneNumber: string;
  hasNewCustomer: boolean;
  orderItemId: number;
  orderId: number;
  quantity: number;
  substitutedBy: any;
  hasSubstitutionRequest: boolean;
  substitutionChoice: SubstitutionChoice;
  substitutionOptions: SubstitutionOptions[];
  updatedPricePerQuantity: number;
  updatedQuantity: number;
  order: {
    buyerChatInfo: {
      isVisible: boolean;
      conversationId: string;
      expiresIn: string;
    };
    buyer?: {
      isVip?: boolean;
    };
  };
  itemNote: string | null;
  substitutionNote: string;
}

export interface State {
  isfoundAt: boolean;
  item?: OrderItem;
  buyersForItem: Buyers[];
  reasonsForDropping: any[];
  itemNotes: string;
  hasAnyBuyerInstructions: boolean;
  itemLocationInformation?: ItemLocationInformation;
  orderItemIds: number[];
  constants: any;
  foundAt: Date | null;
  itemStatus: string;
  runData: RunForItemDetail;
  runDataLoading: boolean;
  newRunId: number;
  runId: number;
  newOrderId: number;
  aoosData: AOOSData;
}

export interface StoreForItemDetail {
  id: number;
  elasticSearchIndex: string;
  storeMasterId: number;
}

export interface RunForItemDetail {
  id: number;
  store: StoreForItemDetail;
}

export interface GetRunForItemDetailResponse {
  getRun: RunForItemDetail;
}

export interface DynamicTextsProps {
  buttonText?: string;
  onButtonClick?: () => any;
  type?: DynamicTextType;
  orderId?: number;
}

export interface GetBuyersForItemsResponse {
  itemWithBuyersAndSub: Buyers[];
}

export interface BuyerChatInfo {
  conversationId: string;
  isVisible: boolean;
}

export interface FetchMaskedNumberVariable {
  orderId: number;
  runId: number;
}

export interface FetchMaskedNumberResponse {
  fetchMaskedNumber: string | null;
}

export interface UpdateOrderItemQtyVariables {
  orderItemId: number;
  itemQuantity: number;
}

export interface UpdateOrderItemQuantityResponse {
  updateOrderItemQuantity: OrderItemHome;
}

export interface GetStoreCategoriesResponse {
  categoryDropdown: string[];
}

export interface UpdateCategoryResponse {
  updateCategoryByShopper: boolean;
}

export interface AdjacentOOSItemFoundArgs {
  adjacentOOSId: number;
}

export interface GetItemsToLocateArgs {
  adjacentOOSId?: number;
  runId?: number;
}

export interface GetItemsToLocateDataV100 {
  adjacentOOSItems?: GetItemsToLocateData[];
}

export interface GetItemsToLocate {
  V100: GetItemsToLocateDataV100;
}

export interface GetItemsToLocateRes {
  data?: GetItemsToLocate;
}

export interface GetItemsToLocateResponse {
  getItemsToLocate: GetItemsToLocateRes;
}

export interface AdjacentOOSItemFoundRes {
  V100: any;
}

export interface AdjacentOOSItemFound {
  data?: AdjacentOOSItemFoundRes;
}

export interface HandleItemFoundResponse {
  adjacentOOSItemFound: AdjacentOOSItemFound;
}

export interface AOOSCatalogItem {
  id: number;
  name: string;
  itemImageUrl: string;
  price: number;
  quantity: number;
}

export interface AOOSData {
  shopperStatus: AOOSShopperStatus;
  conversationId: string;
  newItem: AOOSCatalogItem;
  originalItem: AOOSCatalogItem;
  originalShopper: {
    id: number;
    firstName: string;
  };
  newStore: {
    id: number;
    storeLogoUrl: string;
  };
  originalStore: {
    id: number;
    storeLogoUrl: string;
  };
}

export interface GetItemsToLocateData {
  foundAt: Date;
  id: number;
  itemStatus: string;
  newRunId: string;
  newShopperId: string;
  orderId: number;
  orderItemId: number;
  orderItem: OrderItem;
  runId: number;
  aoosData: AOOSData;
}

export interface SnoozedItemsData {
  [key: number]: string;
}
